module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-card-wrapper"
  }, [_c('div', {
    staticClass: "board-card-header"
  }, [_c('div', {
    staticClass: "info-card",
    class: _vm.andon ? 'andon' : ''
  }, [_c('div', {
    staticClass: "card-id"
  }, [_vm._v(_vm._s(_vm.cardId))]), _vm._v(" "), _c('div', {
    staticClass: "card-contact"
  }, [_vm._v(_vm._s(_vm.cardContact))])]), _vm._v(" "), _c('div', {
    staticClass: "andon-lead-info",
    class: _vm.andon ? 'andon' : ''
  }, [_c('p', {
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.computedLeadTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "board-card-content",
    class: _vm.andon ? 'andon' : ''
  }, [_c('div', {
    staticClass: "description-card"
  }, [_vm._v(_vm._s(_vm.cardDescription))]), _vm._v(" "), (_vm.internalSupplier) ? _c('div', {
    staticClass: "internal-supplier-info"
  }, [_vm._v("Carte attribuée à : "), _c('b', [_vm._v(_vm._s(_vm.internalSupplier))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "asking-date-format",
    class: _vm.andon ? 'andon' : ''
  }, [_vm._v(_vm._s(_vm.askingDate))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32e7f848","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/BoardCard.vue
// module id = 708
// module chunks = 1